import styled from 'styled-components';
// import { palette } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';

const RedirectResetSuccessWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: #edf2fa;

  .header {
    margin: auto;
    padding: 30px;
    display: flex;
    flex-direction: row;
    text-align: left;
    background-color: #ffffff;
    align-items: center;
    border-radius: 10px;
    width: 500px;

    &--icon {
      img {
        width: 100px;
      }
    }

    @media only screen and (max-width: 450px) {
      margin: auto;
      padding: 30px;
      display: flex;
      flex-direction: column;
      text-align: left;
      background-color: #ffffff;
      align-items: center;
      border-radius: 10px;
      width: 200px;
      font-sie: 10px;
    }
  }

  .footer {
    padding-bottom: 50px;
  }

  .resetSuccessLabel {
    width: 350px;
    padding: 10px 10px 10px 10px;

    @media only screen and (max-width: 450px) {
      width: 210px;
      padding: 10px 10px 10px 10px;
    }
  }

  .labelThankyou {
    font-size: 20px;
    padding-top: 10px;
    font-weight: bold;
  }
  .headerChild1 {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 5px;
    color: #fa541c;
  }
  .headerChild2 {
    text-align: center;
  }
`;

export default WithDirection(RedirectResetSuccessWrapper);
